import { REQUEST_STATUSES } from "@/constants";
import { getErrorResponse } from "@/utils/helper";

import { api } from "./instance";

export class FavoriteService {
  static async addFavorite(propertyId, experienceId) {
    try {
      const resp = await api({
        method: "post",
        url: `/api/v2/favorites/${propertyId}/${experienceId}`,
        data: {},
      });
      return {
        resp: resp.data,
        err: null,
        status: REQUEST_STATUSES.SUCCEEDED,
      };
    } catch (err) {
      return {
        resp: null,
        err: getErrorResponse(err),
        status: REQUEST_STATUSES.FAILED,
      };
    }
  }

  static async deleteFavorite(propertyId, experienceId) {
    try {
      const resp = await api({
        method: "delete",
        url: `/api/v2/favorites/${propertyId}/${experienceId}`,
      });

      return {
        resp: resp.data,
        err: null,
        status: REQUEST_STATUSES.SUCCEEDED,
      };
    } catch (err) {
      return {
        resp: null,
        err: getErrorResponse(err),
        status: REQUEST_STATUSES.FAILED,
      };
    }
  }
}
